import { useMemo } from 'react';
import { type Proximity } from '../../../_shared/types/proximity/proximity.types';
import { useIsMapInteractionActive } from '../../../_shared/utils/hooks/useIsMapInteractionActive';
import {
  useActiveProximitySelector, useHoveredProximitySelector,
} from '../../../store/frontendState/activeMapElements/activeMapElements.selectors';

export const useProximityStates = <T extends Proximity>(proximity: T) => {
  const hoveredProximity = useHoveredProximitySelector();
  const activeProximity = useActiveProximitySelector();
  const isMapInteractionActive = useIsMapInteractionActive();

  return useMemo(() => {
    const isHovered = !isMapInteractionActive && hoveredProximity?.proximityId === proximity.id;
    const isActive = !isMapInteractionActive && activeProximity?.proximityId === proximity.id;

    return {
      isHovered,
      isActive,
      activeRowId: activeProximity?.spreadsheetRowId,
      hoveredRowId: hoveredProximity?.spreadsheetRowId,
    };
  },
  [isMapInteractionActive, hoveredProximity?.proximityId, hoveredProximity?.spreadsheetRowId, proximity.id,
    activeProximity?.proximityId, activeProximity?.spreadsheetRowId]);
};
